import { render, staticRenderFns } from "./icon-user.vue?vue&type=template&id=67d50be9&"
import script from "./icon-user.vue?vue&type=script&lang=js&"
export * from "./icon-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports